// extracted by mini-css-extract-plugin
export default {"progressWrap":"styles_progressWrap__fwAxm","segments":"styles_segments__90Tk2","segment":"styles_segment__9HRkZ","segmentOn":"styles_segmentOn__OXE5M"};